import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fcad625"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column gap-2 border-round-3xl w-full border-1 border-gray-200 px-4 py-3 no-underline hover:border-primary" }
const _hoisted_2 = { class: "flex gap-2 align-items-center" }
const _hoisted_3 = { class: "text-primary-600 font-semibold mt-1" }
const _hoisted_4 = { class: "flex flex-column gap-2 mt-2" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = {
  key: 0,
  class: "flex gap-2 align-items-center text-sm text-gray-600"
}
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "flex gap-2 align-items-center justify-content-between text-sm text-gray-600" }
const _hoisted_9 = { class: "text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeedbackTypeIcon = _resolveComponent("FeedbackTypeIcon")!
  const _component_IconChevronRight = _resolveComponent("IconChevronRight")!
  const _component_IconMapPin = _resolveComponent("IconMapPin")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: { name: 'PublicFeedbackById', params: { id: _ctx.feedback.id } }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FeedbackTypeIcon, {
            type: _ctx.feedback.type?.name ?? null
          }, null, 8, ["type"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.feedbackLocale), 1),
          _createVNode(_component_IconChevronRight, { class: "ml-auto text-xs" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.feedback.title), 1),
          (_ctx.feedback.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_IconMapPin),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.feedback.address), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Divider, { class: "my-2" }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("public_feedback.published")) + ": " + _toDisplayString(_ctx.$moment(_ctx.feedback.time).format("DD.MM.YYYY")), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("public_feedback.completed")) + ": " + _toDisplayString(_ctx.$moment(_ctx.feedback.published_message?.created_at).format("DD.MM.YYYY")), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}